import React from "react";
import logo from '../asset/img/mastinLogo-1.png';
import './Footer.css';

const Footer: React.FC = () => {
    return(
        <footer className="footer">
            <img className="logo-footer" src={logo} alt="" />
        </footer>
    );
}

export default Footer;